import { render } from "./AuthCallbackView.vue?vue&type=template&id=f7225d9c"
import script from "./AuthCallbackView.vue?vue&type=script&lang=js"
export * from "./AuthCallbackView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__